const guards = new Set<() => boolean>();

export function registerNavigationGuard(guard: () => boolean) {
  guards.add(guard);
  return () => { guards.delete(guard); };
}

/** 화면이 가진 초안·저장 상태만 이동 허용 여부를 결정합니다. */
export function confirmNavigation() {
  return Array.from(guards).every((guard) => guard());
}

export function isNavigationGuardActive(guard: () => boolean) {
  return guards.has(guard);
}

/** 로그아웃·세션 전환이 완료됐거나 인증이 만료된 뒤에는 이전 화면의 초안을 유지할 수 없습니다. */
export function clearNavigationGuardsAfterSessionChange() {
  guards.clear();
}
